import { useMemo, useState } from "react";
import { useTable } from "react-table";
// import { formatCurrency } from "../../../../helpers";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { EyeIcon } from "../../../../assets/svgIcons";
import { useSelector } from "react-redux";

export const useGRItemsTable = ({ GRItems = [], GRDetails = null }) => {
  const [isOtherDetails, setIsOtherDetails] = useState(null);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const storeMap = useMemo(() => {
    return (storeList || []).reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});
  }, [storeList]);

  const columns = useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "product_name",
      },
      {
        Header: "Store",
        accessor: "store_id",
        Cell: ({ cell: { value } }) => storeMap[value]?.name || "N/A",
      },
      {
        Header: "Ordered Qty",
        accessor: "requested_quantity",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${globalStyles.statusBlock}`}
            style={{ minWidth: "40px" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "QTY Received",
        accessor: "quantity_received",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${globalStyles.statusBlock}`}
            style={{ minWidth: "auto" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "QTY received (Till date)",
        accessor: "total_received",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${globalStyles.statusBlock}`}
            style={{ minWidth: "auto" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "Pending Qty",
        Cell: ({ row }) => {
          const quantity_short = Number(
            row?.original?.remaining_receivable || 0,
          );

          return (
            <span
              className={`${quantity_short <= 0 ? globalStyles["statusBlock--success"] : globalStyles["statusBlock--failed"]}`}
              style={{ minWidth: "auto" }}
            >
              {quantity_short}
            </span>
          );
        },
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Other Details",
        Cell: ({ row }) => (
          <span
            className={" d-flex align-items-center cursor-pointer purple--text"}
            onClick={() =>
              setIsOtherDetails({
                product_name: row.original.product_name,
                index: row.index,
              })
            }
          >
            <EyeIcon className="mr-1" />
            <span>View</span>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: GRItems || [],
  });

  return {
    isOtherDetails,
    setIsOtherDetails,
    instance,
  };
};
